import { createGlobalStyle } from 'styled-components';

export const CuraleafFonts = createGlobalStyle`
  @font-face {
    font-family: Biennale;
    font-weight: 300;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-Light.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 300;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-LightIt.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-Regular.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 400;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-RegularIt.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 500;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-Medium.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 500;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-MediumIt.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-Bold.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 700;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-BoldIt.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 900;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-Heavy.woff2) format('woff2');
  }

  @font-face {
    font-family: Biennale;
    font-weight: 900;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/Biennale-HeavyIt.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 300;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-Light.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 300;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-LtIt.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 400;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-Regular.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 400;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-It.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 500;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-Medium.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 500;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-MdIt.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 700;
    font-style: normal;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-Bold.woff2) format('woff2');
  }

  @font-face {
    font-family: HelveticaNowText;
    font-weight: 700;
    font-style: italic;
    font-display: block;
    src: url(https://assets2.dutchie.com/fonts/HelveticaNowText-BdIt.woff2) format('woff2');
  }
`;
